export const NotificationType = Object.freeze({
  ALERT: "ALERT",
  ORDER_STATUS: "ORDER_STATUS",
  INFO: "INFO",
  PROMOTION: "PROMOTION",
});

export const NotificationPriority = Object.freeze({
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
});

export const PRIORITY_OPTIONS = Object.freeze([
  { value: NotificationPriority.LOW, label: "Low", color: "grey.500", bgColor: "grey.100" },
  { value: NotificationPriority.MEDIUM, label: "Medium", color: "warning.main", bgColor: "warning.lighter" },
  { value: NotificationPriority.HIGH, label: "High", color: "error.main", bgColor: "error.lighter" },
]);

export const BROADCAST_TYPES = Object.freeze([
  { value: "systemUpdate", label: "System Update", category: "SYSTEM" },
  { value: "systemMaintenance", label: "Maintenance Notice", category: "SYSTEM" },
  
  { value: "orderCreated", label: "Order Created", category: "ORDER" },
  { value: "orderUpdated", label: "Order Updated", category: "ORDER" },
  { value: "orderShipped", label: "Order Shipped", category: "ORDER" },
  { value: "orderDelivered", label: "Order Delivered", category: "ORDER" },
  { value: "orderCancelled", label: "Order Cancelled", category: "ORDER" },
  
  { value: "paymentSuccess", label: "Payment Success", category: "PAYMENT" },
  { value: "paymentFailed", label: "Payment Failed", category: "PAYMENT" },
  { value: "paymentRefunded", label: "Payment Refunded", category: "PAYMENT" },
  
  { value: "accountSecurity", label: "Security Alert", category: "ACCOUNT" },
  { value: "tierUpgrade", label: "Tier Upgrade", category: "ACCOUNT" },
  { value: "welcome", label: "Welcome Message", category: "ACCOUNT" },
  
  { value: "newOffer", label: "Promotion / Offer", category: "PROMOTION" },
  { value: "flashSale", label: "Flash Sale", category: "PROMOTION" },
  { value: "cashbackEarned", label: "Cashback Earned", category: "PROMOTION" },
]);
